/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Statistics_Synced_DocumentsInputs */



/**
* | output |
* | --- |
* | "Synced Documents" |
*
* @param {Spaces_File_Statistics_Synced_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_statistics_synced_documents = /** @type {((inputs?: Spaces_File_Statistics_Synced_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Statistics_Synced_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierte Dokumente")
	return /** @type {LocalizedString} */ ("Synced Documents")
});